import { useContext, useEffect, useState } from "react";
import DataContext from "../../../context/DataContext";
import styles from "./styles/NavLogo.module.css";

const NavLogo = ({ height }) => {
    const { currentCustom } = useContext(DataContext);
    const [svgContent, setSvgContent] = useState("");

    useEffect(() => {
        if (currentCustom?.logo?.content) {
            // Remove the XML declaration if present
            const cleanedSvg = currentCustom.logo.content
                .replace(/<\?xml[^>]*>\s*/, "")
                .replace(
                    /<svg([\s\S]*?)>/,
                    (match, p1) => `<svg${p1}   height="100%">`
                );
            setSvgContent(cleanedSvg);
        } else {
            setSvgContent("");
        }
    }, [currentCustom?.logo?.content]);

    const renderSvg = () => {
        if (svgContent) {
            return (
                <div
                    className={`${styles.svg_container}`}
                    dangerouslySetInnerHTML={{ __html: svgContent }}
                    style={{
                        height: height,
                        width: "auto",
                    }}
                />
            );
        } else {
            return (
                <img
                    className={`${styles.logo_image}`}
                    src="/logo.svg"
                    alt="logo"
                    height={height}
                    draggable="false"
                />
            );
        }
    };

    return <div>{renderSvg()}</div>;
};

export default NavLogo;
